import { useState, useEffect } from "react";
import useGetUserBySession from "./useGetUserBySession";

const useValidateSession = () => {
    const url = new URLSearchParams(window.location.search);
    const session = url.get("session");
    const [isValid, setIsValid] = useState<boolean | null>(null);

    useEffect(() => {
        if (!session) {
            setIsValid(false);
            return;
        }

        const validate = async () => {
            try {
                const valid = await useGetUserBySession(session);
                setIsValid(valid);
            } catch (error) {
                console.log("Erro ao puxar sessão");
                setIsValid(false);
            }
        };
        
        validate();
    }, [session]);

    return isValid;
};

export default useValidateSession;
